import app from "./app.reducer";
import brokerCheck from "./brokercheck.reducer";
import client from "./client.reducer";
import custodian from "./custodian.reducer";
import disclosure from "./disclosure.reducer";
import fee from "./fee.reducer";
import feed from "./feed.reducer";
import household from "./household.reducer";
import metric from "./metric.reducer";
import portfolio from "./portfolio.reducer";
import quik from "./quik.reducer";
import user from "./user.reducer";
import users from "./users.reducer";
import redtail from "./redtail.reducer";

import { combineReducers } from "redux";

export default combineReducers({
  app,
  brokerCheck,
  client,
  custodian,
  disclosure,
  fee,
  feed,
  household,
  metric,
  portfolio,
  quik,
  user,
  users,
  redtail,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js